import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const senderTypeRoutes = [
  {
    path: "/directories/sender-type",
    name: "SenderTypeList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "senderType" */ "./components/List"),
  },
];
